(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["revogan-language-options"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('details[data-language-selector][open]').forEach((selector) => {
      if (!selector.contains(event.target)) selector.open = false;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[data-language-selector][open]').forEach((selector) => {
      selector.open = false;
      if (selector.contains(document.activeElement)) selector.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
